import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  title: {
    paddingBottom: theme.spacing[3],
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: theme.spacing[4],
    paddingHorizontal: theme.spacing[4],
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    backgroundColor: colors.backgroundPrimary,
  },
  rowSelected: {
    borderColor: colors.borderSelected,
    backgroundColor: colors.backgroundBrand,
  },
  label: {
    flex: 1,
  },
}));
